import { HStack } from "@chakra-ui/layout";
import { Button } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import {
  type AccountMoveFragment,
  BankAccountMoveStatusEnum,
} from "@src/__generated__/graphql";
import { BankListStoreContext } from "@src/components/modules/bank";
import { observer } from "mobx-react-lite";
import { useContext } from "react";

type ActionsColumnProps = {
  accountMove: AccountMoveFragment;
};
export const ActionsColumn = observer(function ActionsColumn({
  accountMove,
}: ActionsColumnProps) {
  const store = useContext(BankListStoreContext);

  return (
    <HStack justify="end" spacing="2">
      <Button
        colorScheme="grey"
        isLoading={store.loadingRowId === accountMove.id}
        onClick={() => {
          store.matchPaymentModalStore.disclosure.onOpen({
            accountMove,
            onConfirm: () => {
              store.pagination.resetPage();
            },
          });
        }}
        size="sm"
        variant="outline"
      >
        {accountMove.status === BankAccountMoveStatusEnum.NotPaired ||
        accountMove.status === BankAccountMoveStatusEnum.Excluded ? (
          <Trans>Match</Trans>
        ) : (
          <Trans>Match again</Trans>
        )}
      </Button>
      {accountMove.status === BankAccountMoveStatusEnum.NotPaired && (
        <Button
          colorScheme="red"
          isLoading={store.loadingRowId === accountMove.id}
          onClick={() => {
            store.excludeAccountMove(accountMove.id);
          }}
          size="sm"
          variant="outline"
        >
          <Trans>Don't match</Trans>
        </Button>
      )}
    </HStack>
  );
});
